import { useEffect } from "react";
import NewsEvent from "../components/NewsEvent";
import Slider from "../components/Slider";

import { useAappContext } from "../context/AppContext";
import SideNavNewsEvents from "../components/SideNavNewsEvents";

const News = () =>{
    const {getApiData, apiData,isLoadingApiData}=useAappContext()
    useEffect(()=>{
        getApiData('/newsevent/')
    },[])
    if (isLoadingApiData) {
        return <h4 className="Loading"> ........ data Loading!</h4>
    } 
    return (
        <>
        <Slider />
        <section id="newevent" className='section-m1 section-p1'>
        <div className="newevent">

        <div id='page-title' className="title-yellow">
           <span>News & Events</span>
          </div>
         
          <div className="newevent-content">
          
          <div id="ne-continer"> 
        {
            apiData.map((props)=>{
              return  <NewsEvent key={props.id} {...props} />
            })
        }
    
        </div>

          </div>
        </div>
        <SideNavNewsEvents />
      
    </section>
       

        </>
    );
}

export default News;